import React from 'react';
import { motion } from 'framer-motion';
import { useGamification } from '../../contexts/GamificationContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTrendingUp, FiAward, FiTarget } = FiIcons;

const PointsDisplay = () => {
  const { userPoints, userLevel, getPointsToNextLevel } = useGamification();
  const progress = getPointsToNextLevel(userPoints);

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      className="bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg p-4 text-white shadow-lg"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="bg-white/20 p-2 rounded-lg">
            <SafeIcon icon={FiTrendingUp} className="text-xl" />
          </div>
          <div>
            <p className="text-sm opacity-90">Total Points</p>
            <p className="text-2xl font-bold">{userPoints.toLocaleString()}</p>
          </div>
        </div>
        
        <div className="text-right">
          <div className="flex items-center space-x-2">
            <SafeIcon icon={FiAward} className="text-lg" />
            <div>
              <p className="text-sm opacity-90">Level</p>
              <p className="text-xl font-bold">{userLevel}</p>
            </div>
          </div>
        </div>
      </div>
      
      {progress && (
        <div className="mt-3">
          <div className="flex items-center justify-between text-xs mb-1">
            <span>Progress to Level {userLevel + 1}</span>
            <span>{progress.current}/{progress.total}</span>
          </div>
          <div className="w-full bg-white/20 rounded-full h-2">
            <motion.div
              initial={{ width: 0 }}
              animate={{ width: `${(progress.current / progress.total) * 100}%` }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="bg-white rounded-full h-2"
            />
          </div>
          <p className="text-xs mt-1 text-center opacity-90">
            {progress.needed} points to next level
          </p>
        </div>
      )}
    </motion.div>
  );
};

export default PointsDisplay;